import { render, staticRenderFns } from "./FormularioOpcionalAssinaturaDigital.vue?vue&type=template&id=59a5e53f"
import script from "./FormularioOpcionalAssinaturaDigital.vue?vue&type=script&lang=js"
export * from "./FormularioOpcionalAssinaturaDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports